<style scoped lang="less" rel="stylesheet/less">
.course {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  .lottie{
    position: absolute;
    width: 100%;
		height: 720px;
  }
}
.header {
  position: absolute;
  z-index: 99;
  height: 70px;
  width :100%;
  padding-top: 20px;
  .title{
    font-size: 30px;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 500;
    text-align: left;
    color: #ffffff;
    width: 100%;
    text-align: center;
  }
  .tool{
    position: absolute;
    top: 20px;
    right: 40px;
    width: 157px;
    height: 54px;
    background: rgba(255,255,255,.7);
    border-radius: 31px;;
  }
  span {
    position: absolute;
    width: 62px;
    height: 50px;
    background: rgba(0, 0, 0, 0.08)
      url("../../../assets/img/common/arrow_left.png") no-repeat center center;
    background-size: 100% 100%;
    border-radius: 25px 8px 8px 25px;
    left: 30px;
    top: 10px;
    &:hover {
      background: rgba(0, 0, 0, 0.16)
        url("../../../assets/img/common/arrow_left.png") no-repeat center center;
      background-size: 100% 100%;
    }
  }
}
</style>
<template>
  <div class="course">
    <div class="lottie"></div>
    <div class="header">
      <span @click="go_class" class="cursor"></span>
      <div class="title">{{title}}</div>
      <Tool class="tool" :list="gradeList" />
    </div>
    <game-list></game-list>
  </div>
</template>

<script>
import game_list from "./game_list";
import Tool from './tool';
import lottie from "lottie-web-limi";
export default {
  name: "course",
  data() {
    return {
      title:'小狸学具乐园',
      gradeList:[1]
    };
  },
  components: {
    "game-list": game_list,
    Tool
  },
  mounted() {
    this.setLottieSize()
    window.addEventListener('resize', this.setLottieSize)
    this.handleAnimation();
  },
  methods: {
    go_class() {
      //返回班级列表页
      this.$router.push("/class");
    },
    handleAnimation() {
      this.anim = lottie.loadAnimation({
        container: document.querySelector(".lottie"), // the dom element that will contain the animation
        renderer: "svg", //svg,canvas
        loop: true,
        autoplay: true,
        path: `/static/lottie/game/game.json`
      });
    },
    setLottieSize() {
      let clientWidth = document.body.clientWidth
      let clientHeight = document.body.clientHeight
      let lottieDom = document.querySelector(".lottie")
      if(!lottieDom)return;
      if (clientHeight >= 720 && clientWidth >= 1280) {
        if (clientWidth / clientHeight > 1280 / 720) {
          lottieDom.style.width = '100%';
          lottieDom.style.height = 720 / 1280 * clientWidth + 'px';
        } else {
          lottieDom.style.height = '100%';
          lottieDom.style.width = (1280 / 720) * clientHeight + 'px'
        }
      } else if (clientHeight > 720 && clientWidth < 1280) {
        lottieDom.style.height = '100%';
        lottieDom.style.width = (1280 / 720) * clientHeight + 'px'
      } else if (clientHeight < 720 && clientWidth < 1280){
        lottieDom.style.height = '720px';
        lottieDom.style.width = '1280px';
      } else if (clientHeight < 720 && clientWidth > 1280) {
        lottieDom.style.width = '100%';
        lottieDom.style.height = 720 / 1280 * clientWidth + 'px';
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/bussiness/game/gameMenu.vue